import React from 'react'
import { UdAjaxSelect, http, UdAjaxSelectProps } from '@ud/admin-framework'

const AppSelector: React.FC<IAppSelectorProps> = (props) => {
  return (
    <UdAjaxSelect
      query={() => {
        return http.get(props.url!)
      }}
      mapping={{ value: 'value', title: 'name' }}
      {...props as any}
    />
  )
}

AppSelector.defaultProps = {
  url: '/api/uaa/soa/appService/listSimpleApp'
}
export interface IAppSelectorProps extends UdAjaxSelectProps {
  url?: string
}

export { AppSelector }
